export { default } from './PrivacyPolicyLayout';
